export default {
  ARS: 'ARS',
  BRL: 'BRL',
  CLP: 'CLP',
  MILES: 'MILES',
  FFCURRENCY: 'FFCURRENCY' //another way to describe MILES
}
